import React from 'react';
import { IAudience, IDistributionContact } from '../../../../models';
import { ColumnHeader, Table } from '@aon/aon-tws-common-ui';
import { AudiencesParticipantsTableRow } from './AudienceParticipantsTableRow';

export interface IAudienceParticipantsTable {
	participants: IDistributionContact[];
	audiences: IAudience[];
}

const columns = [
	{ label: 'First Name', field: 'firstName', sortAscByDefault: false, isSortable: false, tooltipContent: undefined },
	{ label: 'Last Name', field: 'lastName', sortAscByDefault: false, isSortable: false, tooltipContent: undefined },
	{ label: 'Email', field: 'emailAddress', sortAscByDefault: false, isSortable: false, tooltipContent: undefined },
	{ label: 'Audience', field: 'audience', sortAscByDefault: false, isSortable: false, tooltipContent: undefined },
	{ label: 'Access Code', field: 'accessCode', sortAscByDefault: false, isSortable: false, tooltipContent: undefined },
];

export const AudienceParticipantsTable = (props: IAudienceParticipantsTable) => {
	return (
		<Table responsive={true} lastalign={'left'}>
			<ColumnHeader columns={columns} />
			<tbody>
				{props.participants.map((p: IDistributionContact) => {
					return <AudiencesParticipantsTableRow key={p.personId} participant={p} columns={columns} audiences={props.audiences} />;
				})}
			</tbody>
		</Table>
	);
};
